import React, { useState, useRef, useEffect } from "react"
import { translate } from '../Services/translation'

export default function InfoBox({children, right, darkMode}) {
    const [showInfoBox, setShowInfoBox] = useState(false)
    const [dimensions, setDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });

    const handleResize = () => {
        setDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }

    const getContainerWidth = () => {
        const maxContainerWidth = dimensions.width * 0.9

        if(maxContainerWidth >= 400)
            return 400
        return maxContainerWidth
    }

    const getXposition = (element) => {
        if(element == null)
            return {}
        
        const parentPosition = popupContainer?.current?.offsetParent?.offsetLeft
        const containerWidth = getContainerWidth()
        const windowWidth = window.innerWidth

        if(!parentPosition || !containerWidth)
            return {}

        if(right)
            return {
                right: parentPosition - containerWidth > 0 ? 0 : parentPosition - containerWidth
            }
        
        return {
            left: windowWidth - (parentPosition + containerWidth) > 0 ? 0 : (windowWidth - (parentPosition + containerWidth)) - 20
        }
    }

    useEffect(() => {
        window.addEventListener("resize", handleResize, false);
      }, []);

    const popupContainer = useRef()
    
    return (
        <div 
            onClick={() => setShowInfoBox(!showInfoBox)} 
            className={`pop-up-container ${right ? "right": "left"} ${darkMode ? "dark-mode" : ""}`}>
            <a>
                <i className="fa fa-info-circle fa-1x"></i>
            </a>

            <div ref={popupContainer} style={getXposition(popupContainer?.current)} className={`pop-up ${showInfoBox ? "show" : ""}`}>
                {children}
                <button className="pop-up__close-button">
                    {translate("infobox.close")}
                </button>
            </div>

        </div>
    )
}